import { ModelEntityType } from '@upright/common/model/input/types';
import { removeTagsFromKeyTakeawayString } from '@upright/common/model/output/scores/key-takeaways';
import { KTAttr, KTTag } from '@upright/common/model/output/scores/key-takeaways/types';
import { InternalInlineLink } from '@upright/ui/common/generic/content/texts/inline-link';
import { getModelEntityUrl } from '@upright/ui/untidy/urls';
import Skeleton from 'react-loading-skeleton';
import reactStringReplace from 'react-string-replace';
import styled from 'styled-components';

export function getKeyTakeawayJsx(
  input: string,
  isLoading: boolean,
  entityIdsWithAccess?: string[],
  linkEntityType?: ModelEntityType,
  disableLinks?: boolean,
) {
  // Catches all the HTML-style tags (that begin with <> and end with </>) and replaces them with appropriate JSX elements.
  const elements = reactStringReplace(input, /(<[^>]*>.*?<\/[^>]*>)/g, (match, index) => {
    const openingTagWithAttribute = match.split('>')[0].replace('<', '');
    const tagElements = openingTagWithAttribute.split(' ');
    const tag = tagElements[0];
    // OA: These typings are messed up, fix if you have time to check that the fix doesn't break anything
    const attribute = tagElements[1] as string | undefined;
    const attributeElements = attribute?.split('=');
    const attributeName = attributeElements?.[0];
    const attributeValue = attributeElements?.[1].replace(/"/g, '');

    const value = removeTagsFromKeyTakeawayString(match);

    switch (tag) {
      case KTTag.Entity: {
        const id = attributeName === KTAttr.ID ? attributeValue : undefined;
        const canAccess = !!id && entityIdsWithAccess?.includes(id);
        if (isLoading) return <Skeleton key={index} width={'5em'} inline />;
        if (!id || !canAccess || !linkEntityType) {
          return value;
        }
        if (disableLinks) {
          /* Looks like a link but isn't. Handy for e.g. RenderView */
          return <strong key={index}>{value}</strong>;
        }
        return (
          <Link key={index} to={getModelEntityUrl(linkEntityType, id, value)}>
            {value}
          </Link>
        );
      }
      case KTTag.IMPACT:
      case KTTag.VALUE_SET:
        return <em key={index}>{value}</em>;
      default:
        return value;
    }
  });
  return elements;
}

const Link = styled(InternalInlineLink)`
  text-decoration: none;
`;
